import UniteRepresentativeBlockView from './View';

export const UniteRepresentativeBlockEdit = (props) => {
  return <UniteRepresentativeBlockView {...props} />;
};

export default UniteRepresentativeBlockEdit;
